// Accordion web component, with smooth animation and keyboard support
(() => {
    const template = document.createElement('template');
    template.innerHTML = `
    <style>
    :host {
      display: block;
    }
    
    .accordion-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: var( --header-padding , 0.8rem 1rem);
    }

    .accordion-header svg {
      transition: .3s
    }
    .accordion-header[aria-expanded="false"] svg {
      transform: rotate(-180deg);
    }
    .accordion-pannel {
      overflow: hidden;
      height: 0px;
      will-change: height;
    }
    </style>
    <div class="accordion">
      <div class="accordion-header" role="button" aria-expanded="false" tabindex="0">
        <slot name="header"></slot>
                     <svg
                  width="12px"
                  height="7px"
                  viewBox="0 0 12 7"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g stroke="none" stroke-width="1" fill="none">
                      <path d="M6.05023193,6.71226044 L6.02769279,6.73479958 L5.6741394,6.38124619 L1.14644661,1.85355339 L0.792893219,1.5 L1.5,0.792893219 L1.85355339,1.14644661 L6.02825928,5.3211525 L10.2249378,1.12447395 L10.5784912,0.770920563 L11.285598,1.47802734 L10.9320446,1.83158073 L6.40435181,6.35927353 L6.05079842,6.71282692 L6.05023193,6.71226044 Z" fill="#000000"></path>
                  </g>
                </svg>
      </div>
      <div class="accordion-pannel">
        <slot name="pannel"></slot>
      </div>
    </div>
  `;

    class Accordion extends HTMLElement {

        constructor() {
            super();

            const { targetInput, value, open, header } = this.dataset;
            this.value = this.dataset.value;
            this.targetInput = this.dataset.targetInput;
            this.height = -1;


            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            this.accordion = this.shadowRoot.querySelector('.accordion');
            this.accordionHeader = this.shadowRoot.querySelector('.accordion-header');
            this.accordionPannel = this.shadowRoot.querySelector('.accordion-pannel');

            if (this.classList.contains('fixed-height')) {
                this.height = this.accordionPannel.scrollHeight
            }



            this.init();



            setTimeout(() => {
                this.accordionPannel.style.transition = 'height 0.45s ease-in-out';
            }, 100);

            this.accordionHeader.addEventListener('click', this.toggleAccordion.bind(this));
            this.accordionHeader.addEventListener('keyup', this.toggleAccordion.bind(this));
            this.classList.remove('opacity-0')
            if (!this.classList.contains('filter-accordion')) {
                window.addEventListener('click', (e) => {
                    if (this.contains(e.target)) {
                        // Clicked in box
                    } else {
                        this.setAccordionClosed()
                    }
                });
            }

            if (open) {
                this.setAccordionOpen();
                this.accordionPannel.style.height = 'auto';
            }

            if (header) {
                this.accordionHeader.remove();
                this.accordionPannel.style.height = 'auto';
            }
        }
        init() {

            const input = this.querySelector('.select__select')
            this.querySelectorAll(`[data-value]`).forEach((el) => {

                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.value = e.target.dataset.value;
                    input.value = e.target.dataset.value;
                    // input.dispatchEvent(new Event('input'))
                    input.closest('form').dispatchEvent(new Event('input'));
                    if (!this.classList.contains('filter-accordion')) {
                        this.setAccordionClosed()
                    }
                    el.classList.add('selected');
                });
            });
        }
        setAccordionOpen() {
            this.accordionHeader.setAttribute('aria-expanded', 'true');
            this.accordionPannel.style.height = `${(this.height > -1) ? this.height : this.accordionPannel.scrollHeight}px`
            this.classList.add('open')
            this.dispatchEvent(new Event("open"));
        }
        close() {
            this.setAccordionClosed();
        }

        setAccordionClosed() {
            this.accordionHeader.setAttribute('aria-expanded', 'false');
            this.accordionPannel.style.height = '0px'
            this.classList.remove('open');
            this.dispatchEvent(new Event("close"));
        }

        toggleAccordion(e) {
            const { locked: isLocked = false } = this.dataset;
            if (e.type === 'keyup' && e.code !== 'Enter' && e.code !== 'Space') return;
            if (isLocked === 'true') return;

            if (this.accordionHeader.getAttribute('aria-expanded') === 'true') {
                this.setAccordionClosed()
            } else {
                this.setAccordionOpen()
            }
        }
    }
    customElements.define('custom-select', Accordion);
})();
